export interface FilterGroup {
  key: string;
  title: string;
  options: string[];
}

interface FilterPanelProps {
  groups: FilterGroup[];
  selected: Record<string, string[]>;
  onToggle: (key: string, value: string) => void;
  onReset: () => void;
}

export default function FilterPanel({ groups, selected, onToggle, onReset }: FilterPanelProps) {
  const hasSelection = Object.values(selected).some((list) => list.length > 0);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h2>
        {hasSelection && (
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-accent-600"
          >
            重置
          </button>
        )}
      </div>

      {groups.map((group) => (
        <div key={group.key} className="border-t border-background-100 pt-4 first:border-t-0 first:pt-0">
          <h3 className="mb-2.5 text-sm font-semibold text-foreground-800">{group.title}</h3>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = selected[group.key]?.includes(option) ?? false;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => onToggle(group.key, option)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
                    active
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}